import TransportListCardHeader from './TransportListCardHeader';
import BoxWithBanner from 'components/box/BoxWithBanner';
import {
	Colors,
	ColorStatusGroupHEX,
	ColorBackgroundHEX,
} from 'utils/color/ColorPalette'
import Typography, {
	TypographyType,
} from 'components/typography/karim/Typography';
import LoadingWheel from 'components/loadingWheel/LoadingWheel';
import {
	Assignment,
} from 'models/assignment.model';
import {
	AssignmentFilterType,
	isTodo,
	isDone,
	countAllTodoOnFilter,
	countAllDoneOnFilter,
} from 'utils/transport';
import {
	SvgDone,
} from 'components/svg/Svg';
import {
	useEffect,
	useState,
} from 'react';
import './transportList.scss';
interface TransportListProps {
	datas: Assignment[];
	filter: AssignmentFilterType;
	isLoading: boolean;
}

const AssignmentsTodo = ({
	hasWork = true,
}) => {
	return (
		<div className="transport-list-todo">
			<SvgDone />

			<div
				style={{
					paddingTop: '16.8px', textAlign: 'center',
				}}
			>
				<Typography
					type={TypographyType.headingsH5}
					style={{
						color: '#5C5C5C',
					}}
				>
					Ingen utestående
				</Typography>
				<Typography
					type={TypographyType.karimTextCaptionRegular}
					style={{
						color: '#5C5C5C',
					}}
				>
					{hasWork ? 'Alle oppgaver for dagen er fullført' : 'Fant ingen jobber for gjeldene dag'}
				</Typography>
			</div>
		</div>
	);
}

const CardsHeader = ({
	text,
}: any) => (
	<div className="transport-list-header">
		<Typography type={TypographyType.headingsH5}>
			{text}
		</Typography>
	</div>
);

const TransportList = ({
	isLoading,
	datas,
	filter,
}: TransportListProps) => {
	const [assignments, setAssignments] = useState<Assignment[]>([]);
	const countTodoFiltered = countAllTodoOnFilter(datas, filter);
	const countDoneFiltered = countAllDoneOnFilter(datas, filter);

	useEffect(() => {
		const location = (direction: string) =>
			direction === AssignmentFilterType[AssignmentFilterType.PICKUP] ? 'source' : 'destination';

		// Sort based on timeslots
		setAssignments(datas.sort((a, b) =>
			new Date(a.route[location(a.direction)].time.start).getTime()
				- new Date(b.route[location(b.direction)].time.start).getTime()
		));
	}, [datas]);

	const inTodoList = (assignment: Assignment) =>
		isTodo(assignment) && (filter === AssignmentFilterType.ALL || AssignmentFilterType[filter] === assignment?.direction);
	const inDoneList = (assignment: Assignment) =>
		isDone(assignment) && (filter === AssignmentFilterType.ALL || AssignmentFilterType[filter] === assignment?.direction);

	return (
		<div className="transport-list">
			<CardsHeader text={`ARBEID (${countTodoFiltered})`}/>

			{!isLoading && assignments.filter(
				data => isTodo(data) && (filter === AssignmentFilterType.ALL || AssignmentFilterType[filter] === data?.direction)
			).length === 0 && (
				<AssignmentsTodo hasWork={assignments.length > 0} />
			)}

			{isLoading && (
				<LoadingWheel message="Vennligst vent ..." />
			)}

			{!isLoading && assignments && assignments.filter(assignment => inTodoList(assignment)).map(assignment => (
				<BoxWithBanner
					key={`work-todo-${assignment.id}`}
					bannerColor={
						assignment?.direction === AssignmentFilterType[AssignmentFilterType.DELIVERY] ?
							Colors.extras.green.t500.hex :
							ColorStatusGroupHEX.main.primary
					}
					backgroundColor={ColorBackgroundHEX.white.primary}
				>
					<TransportListCardHeader data={assignment}/>
				</BoxWithBanner>
			))}

			<CardsHeader text={`FERDIG (${countDoneFiltered})`}/>

			{assignments.filter(assignment => inDoneList(assignment)).map(assignment => (
				<BoxWithBanner
					key={`work-done-${assignment.id}`}
					bannerColor={Colors.neutrals.tints.gy200.hex}
					backgroundColor={ColorBackgroundHEX.white.primary}
				>
					<TransportListCardHeader data={assignment}/>
				</BoxWithBanner>
			))}
		</div>
	);
}

export default TransportList;